import { render, staticRenderFns } from "./LegalStatusDisplay.vue?vue&type=template&id=1ed20838&"
import script from "./LegalStatusDisplay.vue?vue&type=script&lang=js&"
export * from "./LegalStatusDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports